// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signature_border {
  border: 1px solid #000000;
  margin: 2px 1px 7px 1px;
  width: 100%;
  max-height: 250px;
  min-height: 230px;
}

.supportNote {
  display: inline-block;
  margin-left: 10px;
  vertical-align: middle;
  padding-top: 12px;
  font-size: x-small;
}

.sign-option {
  padding: 0px 8px 0px 5px;
}

.signature-footer {
  position: relative;
  bottom: 0rem;
}

.signatureImageUpload {
  width: 100%;
  min-height: 250px;
  object-fit: contain;
}

.signature-fields {
  position: relative;
  width: 100%;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  /* .sign-option {
    padding: 0px 1rem 0px 5px;
  } */
  .supportNote {
    margin-left: 2px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .signature-footer {
    top: 25px;
  }
  /* .sign-option {
    padding: 0px 32px 0px 5px;
  } */
  .signatureImageUpload {
    max-height: -moz-fit-content;
    max-height: fit-content;
  }
}

img[src=''] {
  display: none;
}

.signature_Footer_container {
  display: grid;
  grid-column-gap: 25px;
  grid-template-columns: 88% auto;
  max-width: 100%;
}

.mt-4_3 {
  margin-top: 1.35rem;
}

.signatureOptionRadio {
  position: relative;
  width: 22px;
  height: 14px;
  top: 2px;
}

.signClearButton {
  width: max-content;
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .signature-footer {
    position: fixed;
    bottom: 100px;
    z-index: 9999;
    display: block;
    height: 100px;
    width: 100%;
    line-height: 1.5;
    top: 520px !important;
    border: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/system-common/signatureUI/signatureUI.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;;KAEG;EACH;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,SAAS;EACX;EACA;;KAEG;EACH;IACE,4BAAuB;IAAvB,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;IACf,aAAa;IACb,aAAa;IACb,cAAc;IACd,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;EACb;AACF","sourcesContent":[".signature_border {\n  border: 1px solid #000000;\n  margin: 2px 1px 7px 1px;\n  width: 100%;\n  max-height: 250px;\n  min-height: 230px;\n}\n\n.supportNote {\n  display: inline-block;\n  margin-left: 10px;\n  vertical-align: middle;\n  padding-top: 12px;\n  font-size: x-small;\n}\n\n.sign-option {\n  padding: 0px 8px 0px 5px;\n}\n\n.signature-footer {\n  position: relative;\n  bottom: 0rem;\n}\n\n.signatureImageUpload {\n  width: 100%;\n  min-height: 250px;\n  object-fit: contain;\n}\n\n.signature-fields {\n  position: relative;\n  width: 100%;\n}\n\n@media only screen and (min-width: 320px) and (max-width: 767px) {\n  /* .sign-option {\n    padding: 0px 1rem 0px 5px;\n  } */\n  .supportNote {\n    margin-left: 2px;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n  .signature-footer {\n    top: 25px;\n  }\n  /* .sign-option {\n    padding: 0px 32px 0px 5px;\n  } */\n  .signatureImageUpload {\n    max-height: fit-content;\n  }\n}\n\nimg[src=''] {\n  display: none;\n}\n\n.signature_Footer_container {\n  display: grid;\n  grid-column-gap: 25px;\n  grid-template-columns: 88% auto;\n  max-width: 100%;\n}\n\n.mt-4_3 {\n  margin-top: 1.35rem;\n}\n\n.signatureOptionRadio {\n  position: relative;\n  width: 22px;\n  height: 14px;\n  top: 2px;\n}\n\n.signClearButton {\n  width: max-content;\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {\n  .signature-footer {\n    position: fixed;\n    bottom: 100px;\n    z-index: 9999;\n    display: block;\n    height: 100px;\n    width: 100%;\n    line-height: 1.5;\n    top: 520px !important;\n    border: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
